import CancelListing from "components/cancel-listing/CancelListing";
import ClaimPrizePopup from "components/claim-prize-popup/ClaimPrizePopup";
import MakeOfferPopup from "components/make-offer/MakeOfferPopup";
import BuyWidgetPopup from "components/onramper/BuyWidgetPopup";
import SellWidget from "components/onramper/SellWidget";
import PurchaseWindow from "components/purchase-window/PurchaseWindow";
import PurchaseWindowPaymentCard from "components/purchase-window/PurchaseWindowPaymentCard";
import ReceivedOfferPopup from "components/received-offer/ReceivedOfferPopup";
import RedeemPrizePopup from "components/redeem-prize/RedeemPrizePopup";
import ReturnIdentityPopup from "components/return-identity/ReturnIdentityPopup";
import SellPopup from "components/sell-popup/SellPopup";
import useActiveItem from "hooks/useActiveItem";
import useEffectOnce from "hooks/useEffectOnce";
import { usePopup } from "hooks/usePopup";
import { useRefreshItems } from "hooks/useRefreshItems";
import { useRemoveActiveItem } from "hooks/useRemoveActiveItem";
import { useSoundPath } from "hooks/useSoundPath";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { changeQuantity } from "store/popups";

const PagePopups = () => {
  const {pathname,  search } = useLocation();
  const dispatch = useDispatch();
  const setPopupHook = usePopup();
  const refreshItems = useRefreshItems();
  const removeActiveItem = useRemoveActiveItem();
  const playSound = useSoundPath();
  const { isVisible, type } = useSelector((state) => state.popups);
  const {activeItem} = useActiveItem();
  const params = new URLSearchParams(search);

  const close = () => {
    setPopupHook('close');
    playSound('main');

    if (type === 'purchase' && pathname.includes('buypacks')) {
      dispatch(changeQuantity(0));
    } else if ((type === 'purchase' && !pathname.includes('buypacks')) || type === 'redeem-prize') {
      refreshItems();
      removeActiveItem();
    } else if(type === 'offer') {
      removeActiveItem();
    }
  }

  window.addEventListener('keydown', (e) => {
    if (isVisible && e.key === 'Escape') {
      close()
    }
  })

  useEffectOnce(() => {
    if (params.has('success')) {
      setPopupHook({type: 'purchase-status'})
    }
  })

  if (isVisible) {
    return (
      <>
        {type === 'offer' && <ReceivedOfferPopup close={close} />}
        {type === 'cancel-listing-default' && <CancelListing id={activeItem.marketplace_id} cancelListingType={'default'} close={close} />}
        {type === 'cancel-listing-identity' && <CancelListing id={activeItem.marketplace_id} cancelListingType={'craft-identity'} close={close} />}
        {type === 'cancel-listing-prediction' && <CancelListing id={activeItem.marketplace_id} cancelListingType={'craft-prediction'} close={close} />}
        {type === 'sell' && <SellPopup close={close} />}
        {type === 'redeem-prize' && <RedeemPrizePopup close={close} />}
        {type === 'make-offer' && <MakeOfferPopup close={close} />}
        {type === 'purchase' && <PurchaseWindow close={close} />}
        {type === 'purchase-status' && <PurchaseWindowPaymentCard />}
        {type === 'claim-prize' && <ClaimPrizePopup close={close} />}
        {type === 'return-identity' && <ReturnIdentityPopup close={close} />}
        {type === 'add-funds' && <BuyWidgetPopup close={close} /> }
        {type === 'withdraw-funds' && <SellWidget close={close} /> }
      </>
    )
  }
}

export default PagePopups;
